import { render } from "./addCategory.vue?vue&type=template&id=10ce6f32&scoped=true"
import script from "./addCategory.vue?vue&type=script&lang=js"
export * from "./addCategory.vue?vue&type=script&lang=js"

import "./addCategory.vue?vue&type=style&index=0&id=10ce6f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ce6f32"]])

export default __exports__